// src/components/ServersParser/ServersParserToolbar.jsx
import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const ServersParserToolbar = ({
  resultsCount,
  sortBy,
  onSortChange,
  onCopyAllIps,
  onExportTxt
}) => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const sortOptions = [
    { key: 'online-desc', labelRu: 'По онлайну (убыв.)', labelEn: 'By Online (desc)' },
    { key: 'online-asc', labelRu: 'По онлайну (возр.)', labelEn: 'By Online (asc)' },
    { key: 'vuln', labelRu: 'По уязвимости', labelEn: 'By Vulnerability' },
    { key: 'version', labelRu: 'По версии', labelEn: 'By Version' }
  ];

  const currentOption = sortOptions.find(opt => opt.key === sortBy) || sortOptions[0];

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    if (dropdownOpen) {
      document.addEventListener('click', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [dropdownOpen]);

  return (
    <div className="sp-table-toolbar-row">
      <div className="sp-toolbar-left-side">
        <div className="sp-toolbar-count-label">
          {isEn ? 'Found:' : 'Найдено:'} <b>{resultsCount}</b> {isEn ? 'servers' : 'серверов'}
        </div>

        <div className={`sp-filter-pill-wrapper ${dropdownOpen ? 'open' : ''}`} ref={dropdownRef}>
          <button
            type="button"
            className="sp-filter-pill-trigger"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <span style={{ color: 'var(--sp-text-dimmed)' }}>
              {isEn ? 'Sort:' : 'Сортировка:'}
            </span>
            <span>
              {isEn ? currentOption.labelEn : currentOption.labelRu}
            </span>
            <svg className="sp-chevron" viewBox="0 0 24 24" fill="none">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>

          {dropdownOpen && (
            <div className="sp-filter-dropdown-menu">
              {sortOptions.map((opt) => {
                const isSelected = opt.key === sortBy;
                return (
                  <button
                    key={opt.key}
                    type="button"
                    className={`sp-dropdown-option ${isSelected ? 'selected' : ''}`}
                    onClick={() => {
                      onSortChange(opt.key);
                      setDropdownOpen(false);
                    }}
                  >
                    <span>{isEn ? opt.labelEn : opt.labelRu}</span>
                    <svg viewBox="0 0 24 24" fill="none">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <div className="sp-toolbar-right-side">
        <button
          type="button"
          className="sp-tool-action-btn"
          onClick={onCopyAllIps}
          disabled={resultsCount === 0}
          title={isEn ? 'Copy all IPs to clipboard' : 'Скопировать все IP в буфер'}
        >
          <svg viewBox="0 0 24 24" fill="none">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
          <span>{isEn ? 'Copy All IPs' : 'Скопировать все IP'}</span>
        </button>

        <button
          type="button"
          className="sp-tool-action-btn"
          onClick={onExportTxt}
          disabled={resultsCount === 0}
          title={isEn ? 'Download list in TXT' : 'Скачать список в TXT'}
        >
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          <span>{isEn ? 'Export TXT' : 'Экспорт TXT'}</span>
        </button>
      </div>
    </div>
  );
};

export default ServersParserToolbar;
